module.exports = __webpack_public_path__ + "static/img/bg-slight-production-kontakt.eedd158.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kontakt/bg-slight-production-kontakt.jpg
// module id = Pw+w
// module chunks = 1